export default "__VITE_ASSET__afb4c8cc__"